export default __webpack_public_path__ + "static/media/R6.4075a657.JPG";